var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgilysysEatec(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1193 406.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #0299d6;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #7fbc42;\n      }\n\n      .cls-3 {\n        fill: #231f20;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M487.2,137.1h120.8v24.4h-90.8v69.3h86.9v24.4h-86.9v74.2h91.8v24.4h-121.7v-216.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M729.7,334.3c-9.1,11.4-28.6,22.8-52.1,22.8s-44.6-16.9-44.6-43.3,21.8-43,55.7-45.2c14-1,27.7-1.3,40.4-1.3v-6.8c0-26.4-10.7-42.3-36.5-42.3s-29,4.2-41.3,11.1l-6.8-21.5c16.3-9.8,33.2-13.3,53.4-13.3,36.8,0,60.5,23.4,60.5,65.4v94.1h-28.6v-19.5ZM729.1,315.5v-29c-13,.7-24.1,1.6-35.2,2.9-18.2,2-32.6,7.5-32.6,24.4s9.1,21.8,24.7,21.8,32.2-8.5,43-20.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M778.9,197.6h28v-40h29.3v40h51.4v23.8h-51.4v79.7c0,18.6,3.9,32.2,23.8,32.2s17.9-1.6,24.7-4.2l2.6,22.1c-6.8,2.9-21.5,5.9-33.5,5.9-33.5,0-46.9-23.1-46.9-55v-80.7h-28v-23.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1035.7,257.5c0,8.5-1,17.3-3.3,26.4h-98.6c1,29.9,14.6,50.1,51.1,50.1s31.9-3.9,44.6-9.1l3.9,21.8c-13.7,6.5-33.5,10.4-52.7,10.4-52.1,0-76.8-35.8-76.8-80.7s27-82,71.6-82,60.2,27.3,60.2,63.1ZM933.8,261.4h73.6c2.9-24.4-6.5-45.2-32.9-45.2s-39.1,20.8-40.7,45.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1182.1,202.8l-4.2,22.5c-11.4-4.6-24.4-7.5-37.1-7.5-35.2,0-51.4,23.8-51.4,57.9s16.3,57.9,51.4,57.9,25.7-2.9,37.1-7.5l4.2,22.5c-10.7,5.2-29.3,8.5-43.9,8.5-52.4,0-78.1-37.8-78.1-81.4s25.7-81.4,78.1-81.4,33.2,3.3,43.9,8.5Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M377.7,178.1c46.4,0,84.1-37.6,84.1-84.1S424.2,10,377.7,10s-84.1,37.6-84.1,84.1,37.6,84.1,84.1,84.1"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M263.9,123c10.5,13.7,16.3,32.4,16.3,55.7v118h-35.9v-24.5c-11.4,14.3-35.9,28.6-65.3,28.6s-55.9-21.2-55.9-54.3,27.4-53.9,69.8-56.7c17.6-1.2,34.7-1.6,50.6-1.6v-8.6c0-33.1-13.5-53.1-45.7-53.1s-36.3,5.3-51.8,13.9l-8.6-26.9c20.4-12.2,41.6-16.7,66.9-16.7s12.7.6,18.5,1.8c-17.9-7.2-37.4-11.2-57.9-11.2-85.4,0-154.7,69.3-154.7,154.7s69.3,154.7,154.7,154.7,154.7-69.3,154.7-154.7-21.7-90.5-55.7-118.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M158.6,246.4c0,18.4,11.4,27.3,31,27.3s40.4-10.6,53.9-25.3v-36.3c-16.3.8-30.2,2-44.1,3.7-22.9,2.4-40.8,9.4-40.8,30.6Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgilysysEatec);
export default __webpack_public_path__ + "static/media/AgilysysEatec.34bb31dd264cc6560ee0c3499a7690d3.svg";
export { ForwardRef as ReactComponent };